/*eslint-disable*/
import React, { useState, useEffect, useRef } from "react";
import Highlighter from "react-highlight-words";
import { useSelector, useDispatch } from "react-redux";
import {
  Col,
  Input,
  Typography,
  Popover,
  Button,
  Modal,
  Spin,
  Space,
  Select,
  Row,
  Popconfirm,
  Divider,
  message,
  Checkbox,
  InputNumber,
} from "antd";
import {
  SearchOutlined,
  PlusOutlined,
  LoadingOutlined,
} from "@ant-design/icons";
import { useForm, Controller } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";
import {
  getAllProjects,
  createProject,
  deleteProject,
  updateProject,
  publishedProject,
} from "../Actions/projectsAction";
import { PermissionWrapper } from "../components/PermissionWrapper";
import MyTable from "../components/table";
import "./styles/clients.css";
import { ViewLandProjects } from "../pages/ViewLandProjects";
import { UpdateLandProjects } from "../pages/updateLandProjects";
import { useBreakpoints } from "../components/ResponsiveBreakPoints";
import useColumnSearch from "../Utils/useColumnSearch";
const schema = Yup.object().shape({
  property_name: Yup.string().required("Required"),
  tag_line: Yup.string().required("Required"),
  builder: Yup.string().required("Required"),
  possesion: Yup.string().required("Required"),
});
const { Text, Title } = Typography;

const LandProjects = () => {
  const dispatch = useDispatch();
  const { isMobile } = useBreakpoints();
  const {
    projects,
    isGetProjectsLoading,
    isCreateProjectLoading,
    isUpdateProjectLoading,
    isDeleteProjectLoading,
  } = useSelector((state) => {
    const {
      projects,
      isGetProjectsLoading,
      isCreateProjectLoading,
      isUpdateProjectLoading,
      isDeleteProjectLoading,
    } = state.projects;
    return {
      projects,
      isGetProjectsLoading,
      isCreateProjectLoading,
      isUpdateProjectLoading,
      isDeleteProjectLoading,
    };
  });
  useEffect(() => {
    dispatch(getAllProjects("type=Land"));
  }, []);

  const { register, handleSubmit, errors, clearErrors, control, reset } =
    useForm({
      resolver: yupResolver(schema),
      defaultValues: {
        pre_lease: false,
        pre_launch: false,
        is_sell: false,
        new_r3: false,
      },
      mode: "onChange",
    });
  const [files, setFiles] = useState([]);
  const [name, setName] = useState("");
  const [createDialog, setCreateDialog] = useState(false);
  const [brochurePdf, setBrochurePdf] = useState(null);
  const pdfInputRef = useRef(null);
  const [description, setDescription] = useState([
    { key: "", value: "", id: Math.random() },
  ]);
  const handleResetForm = () => {
    setDescription([...description, { key: "", value: "" }]);
  };
  const handleCreateProject = (data, type, event) => {
    // event.preventDefault();
    data.parking = 0;
    data.image_url = files.length > 0 ? files : null;
    data.project_pdf = brochurePdf ? brochurePdf : null;
    data.project_type = "Land";
    data.description = { description };
    dispatch(
      createProject(
        data,
        "type=Land",
        successCreateLandProject,
        failureCreateLandProject,
      ),
    );
  };
  const successCreateLandProject = () => {
    setFiles([]);
    setName("");
    setBrochurePdf(null);
    setDescription([{ key: "", value: "" }]);
    setCreateDialog(false);
    reset({
      property_name: "",
      no_of_floor: "",
      area_name: "",
      image_url: "",
      builder: "",
      tag_line: "",
      possesion: "",
      google_link: "",
      bhk: "",
      price_range: "",
      new_sequence: "",
      pre_lease: false,
      pre_launch: false,
      is_sell: false,
      new_r3: false,
    });
    setTimeout(() => {
      message.success("You have successfully create land projects.");
    }, 2000);
  };
  const failureCreateLandProject = () => {
    setTimeout(() => {
      message.info("Something went wrong.");
    }, 2000);
    setCreateDialog(false);
    reset();
  };
  const handleAdd = () => {
    const newDescription = description.concat([
      { key: "", value: "", id: Math.random() },
    ]);
    setDescription(newDescription);
  };
  const handleRemove = (id) => {
    const newDescription = description.filter((x) => x.id !== id);
    setDescription(newDescription);
  };
  const handleOnChange = (e, index) => {
    const { name, value } = e.target;
    const newDescription = description;
    const selectedObject = newDescription[index];
    selectedObject[name] = value;
    setDescription(newDescription);
  };
  const handleCancel = () => {
    reset({
      property_name: "",
      no_of_floor: "",
      area_name: "",
      image_url: "",
      builder: "",
      tag_line: "",
      possesion: "",
      google_link: "",
      bhk: "",
      price_range: "",
      new_sequence: "",
      pre_lease: false,
      pre_launch: false,
      is_sell: false,
      new_r3: false,
    });
    if (pdfInputRef.current) {
      pdfInputRef.current.value = "";
    }
    setBrochurePdf(null);
    setFiles([]);
    setName("");
    clearErrors();
    setDescription([{ key: "", value: "" }]);
    setCreateDialog(false);
  };
  const handleImageChange = (event) => {
    const { value } = event.target;
    const files = Array.from(event.target.files);
    setName(value);
    setFiles(files);
  };
  return (
    <Spin
      spinning={
        isGetProjectsLoading ||
        isCreateProjectLoading ||
        isUpdateProjectLoading ||
        isDeleteProjectLoading
      }
    >
      <Modal
        title="Create Land Project"
        open={createDialog}
        onCancel={() => handleCancel()}
        footer={null}
        maskClosable={false}
      >
        <form onSubmit={handleSubmit(handleCreateProject)}>
          <Row gutter={[8, 16]}>
            {files.length > 0 &&
              files?.map((image, index) => (
                <div key={index} style={{ margin: "10px" }}>
                  <img
                    src={URL.createObjectURL(image)}
                    alt={`image-${index}`}
                    style={{
                      width: "100px",
                      height: "100px",
                      objectFit: "cover",
                      borderRadius: "8px",
                    }}
                  />
                </div>
              ))}
            <Col>
              <input
                name="image_url"
                value={name}
                onChange={(e) => handleImageChange(e)}
                multiple
                type="file"
              ></input>
            </Col>
            <Col span={24}>
              <Row>
                <Text>Upload Brochure (PDF)</Text>
              </Row>

              <input
                ref={pdfInputRef}
                type="file"
                accept="application/pdf"
                onChange={(e) => {
                  const file = e.target.files?.[0];
                  if (file && file.type === "application/pdf") {
                    setBrochurePdf(file);
                  } else {
                    message.error("Please upload a valid PDF file");
                    e.target.value = "";
                  }
                }}
              />
            </Col>
            <Col span={24}></Col>
            <Col xl={8} lg={8} md={8} sm={24} xs={24}>
              <Row>
                <Text>Builder</Text>
              </Row>
              <Controller
                as={Input}
                name="builder"
                control={control}
                placeholder="Builder"
              />
              {errors.builder && (
                <span className="error_style">Builder is required</span>
              )}
            </Col>
            <Col xl={8} lg={8} md={8} sm={24} xs={24}>
              <Row>
                <Text>Project Name.</Text>
              </Row>
              <Controller
                as={Input}
                name="property_name"
                control={control}
                placeholder="Property Name."
              />
              {errors.property_name && (
                <span className="error_style">Property Name is required</span>
              )}
            </Col>
            <Col xl={8} lg={8} md={8} sm={24} xs={24}>
              <Row>
                <Text>Area</Text>
              </Row>
              <Controller
                as={Input}
                name="area_name"
                control={control}
                placeholder="Enter area"
              />
              {errors.area_name && (
                <span className="error_style">Area is required</span>
              )}
            </Col>
          </Row>

          <Row gutter={[8, 16]}>
            <Col span={24}></Col>
            <Col xl={8} lg={8} md={8} sm={24} xs={24}>
              <Row>
                <Text>Tag Line</Text>
              </Row>
              <Controller
                as={Input}
                name="tag_line"
                control={control}
                placeholder="Tag Line"
              />
              {errors.tag_line && (
                <span className="error_style">Tag Line is required</span>
              )}
            </Col>
            <Col xl={8} lg={8} md={8} sm={24} xs={24}>
              <Row>
                <Text>Possesion</Text>
              </Row>
              <Controller
                as={Input}
                name="possesion"
                control={control}
                placeholder="Possesion"
              />
              {errors.possesion && (
                <span className="error_style">possesion is required</span>
              )}
            </Col>
            <Col xl={8} lg={8} md={8} sm={24} xs={24}>
              <Row>
                <Text>Google Link</Text>
              </Row>
              <Controller
                as={Input}
                name="google_link"
                control={control}
                placeholder="Enter Google Link"
              />
              {errors.google_link && (
                <span className="error_style">Google Link is required</span>
              )}
            </Col>

            <Col xl={8} lg={8} md={8} sm={24} xs={24}>
              <Row>
                <Text>BHK</Text>
              </Row>
              <Controller
                as={Input}
                name="bhk"
                control={control}
                placeholder="Enter BHK"
              />
            </Col>
            <Col xl={8} lg={8} md={8} sm={24} xs={24}>
              <Row>
                <Text>Price Range</Text>
              </Row>
              <Controller
                as={Input}
                name="price_range"
                control={control}
                placeholder="Enter Price Range 1cr - 5cr"
              />
            </Col>
            <Col xl={8} lg={8} md={8} sm={24} xs={24}>
              <Row>
                <Text>Sequence</Text>
              </Row>
              <Controller
                as={<InputNumber style={{ width: "100%" }} />}
                name="new_sequence"
                control={control}
                placeholder="Enter Sequence"
              />
            </Col>
            <Col xl={8} lg={8} md={8} sm={24} xs={24}>
              <Row>
                <Text>Latitude</Text>
              </Row>
              <Controller
                as={<InputNumber style={{ width: "100%" }} />}
                name="latitude"
                control={control}
                placeholder="Enter Latitude"
              />
            </Col>
            <Col xl={8} lg={8} md={8} sm={24} xs={24}>
              <Row>
                <Text>Longitude</Text>
              </Row>
              <Controller
                as={<InputNumber style={{ width: "100%" }} />}
                name="longitude"
                control={control}
                placeholder="Enter Longitude"
              />
            </Col>

            {/* Changed Resell to New and For sale to Resell  */}
            <Col>
              <Row gutter={[10, 0]}>
                <Col>
                  <Row gutter={[10, 0]}>
                    <Col>
                      <Text>New</Text>
                    </Col>
                    <Col>
                      <Controller
                        name="pre_launch"
                        control={control}
                        render={(props) => (
                          <Checkbox
                            {...props}
                            checked={props.value}
                            onChange={(e) => props.onChange(e.target.checked)}
                          />
                        )}
                      />
                    </Col>
                  </Row>
                </Col>
                <Col>
                  <Row gutter={[10, 0]}>
                    <Col>
                      <Text>New R3</Text>
                    </Col>
                    <Col>
                      <Controller
                        name="new_r3"
                        control={control}
                        render={(props) => (
                          <Checkbox
                            {...props}
                            defaultValue={false}
                            checked={props.value}
                            onChange={(e) => props.onChange(e.target.checked)}
                          />
                        )}
                      />
                    </Col>
                  </Row>
                </Col>
                <Col>
                  <Row gutter={[10, 0]}>
                    <Col>
                      <Text>Resell</Text>
                    </Col>
                    <Col>
                      <Controller
                        name="is_sell"
                        control={control}
                        render={(props) => (
                          <Checkbox
                            {...props}
                            defaultValue={false}
                            checked={props.value}
                            onChange={(e) => props.onChange(e.target.checked)}
                          />
                        )}
                      />
                    </Col>
                  </Row>
                </Col>
              </Row>
            </Col>
          </Row>
          <Divider />
          <Row>
            <Button onClick={handleAdd} type="primary" icon={<PlusOutlined />}>
              Add
            </Button>
          </Row>

          {description.map((des, index) => {
            return (
              <Row key={index} gutter={[8, 16]}>
                <Col span={24}></Col>
                <Col xl={12} lg={12} md={12} sm={24} xs={24}>
                  <Row>
                    <Text>Key</Text>
                  </Row>
                  <Input
                    key={des.id}
                    name={`key`}
                    onChange={(e) => handleOnChange(e, index)}
                    placeholder="e.g. Land, Less, Carpet SqFt"
                  />
                  {/* {errors.description && (
                  <span className="error_style">Type Of BHK is required</span>
                )} */}
                </Col>
                <Col xl={12} lg={12} md={12} sm={24} xs={24}>
                  <Row>
                    <Text>value</Text>
                  </Row>
                  <Input
                    key={des.id}
                    name={`value`}
                    onChange={(e) => handleOnChange(e, index)}
                    placeholder="e.g. 2500.Sqft"
                  />
                  {/* {errors.description && (
                  <span className="error_style">Type Of BHK is required</span>
                )} */}
                </Col>
                {index !== 0 && (
                  <Button type="link" onClick={() => handleRemove(des.id)}>
                    Remove
                  </Button>
                )}
              </Row>
            );
          })}

          <Row justify="end" gutter={[0, 16]}>
            <Col span={24}></Col>
            <Col>
              {isCreateProjectLoading ? (
                <Spin
                  indicator={
                    <LoadingOutlined
                      style={{
                        fontSize: 24,
                      }}
                      spin
                    />
                  }
                />
              ) : (
                <Button type="primary" htmlType="submit">
                  Create Land Project
                </Button>
              )}
            </Col>
          </Row>
        </form>
      </Modal>
      {projects && (
        <AllLandProjects
          data={projects}
          handleDialog={() => setCreateDialog(true)}
        />
      )}
      {/* {projects && <AllProperties data={projects} />} */}
    </Spin>
  );
};
export default LandProjects;

const AllLandProjects = (props) => {
  const { getColumnSearchProps } = useColumnSearch();
  const dispatch = useDispatch();
  const { currentUser } = useSelector((state) => state.users);
  const isAdmin = currentUser?.role === "Admin";
  const { handleDialog } = props;
  const [showSearch, setShowSearch] = useState(false);
  const [currentProject, setCurrentProject] = useState({});

  const onRowSelect = (record) => {
    setCurrentProject(record);
    setShowSearch(true);
  };
  const onTaskRowClick = (task) => {};
  // useEffect(() => {
  //   if (createProject !== {}) {
  //     // dispatch() getTasks
  //     // dispatch() getSearch Properies
  //   }
  // }, [currentProject]);

  const columns = () => [
    {
      title: "Project Name",
      width: 120,
      dataIndex: "property_name",
      key: "1",
      // fixed: "left",
    },
    {
      title: "Project Type",
      key: "status",
      width: 120,

      filters: [
        { text: "New", value: "pre_launch" },
        { text: "New R3", value: "new_r3" },
        { text: "Resell", value: "is_sell" },
      ],

      onFilter: (value, record) => {
        return record?.[value] === true;
      },

      render: (record, row) => {
        return (
          <div>
            {row.pre_launch && <span>New&nbsp;</span>}
            {row.new_r3 && <span>New R3&nbsp;</span>}
            {row.is_sell && <span>Resell</span>}
          </div>
        );
      },
    },
    {
      title: "Sequence",
      width: 80,
      dataIndex: "new_sequence",
      render: (record) => {
        return <div>{record || "-"}</div>;
      },
    },
    {
      title: "Tag Line",
      width: 150,
      dataIndex: "tag_line",
      key: "2",
      // fixed: "left",
    },
    {
      title: "Builder",
      width: 100,
      dataIndex: "builder",
      key: "3",
      // fixed: "left",
    },
    {
      title: "Possesion",
      dataIndex: "possesion",
      key: "5",
      width: 100,
    },
    // {
    //   title: "Parking",
    //   dataIndex: "parking",
    //   key: "4",
    //   // width: 150,
    // },
    {
      title: "Area",
      dataIndex: "area_name",
      key: "6",
      width: 100,
      render: (record, object) => {
        return <div>{record}</div>;
      },
    },
    {
      title: "id",
      width: 90,
      dataIndex: "id",
      key: "7",
      ...getColumnSearchProps("id"),
    },
    {
      title: "Action",
      dataIndex: "id",
      key: "id",
      fixed: "right",
      width: 100,
      render: (id) => (
        <ActionComponent
          id={id}
          type="type=Land"
          published={currentProject.published}
        />
      ),
    },
  ];
  return (
    <>
      <Row className="rowWithPadding" justify="space-between">
        <Col>
          <Title level={4}>All Land Projects({props.data.length})</Title>
        </Col>
        <Col>
          <PermissionWrapper
            resource="projects_land"
            action="create"
            disabled={true}
          >
            <Button type="primary" onClick={() => handleDialog()}>
              Create Land Project
            </Button>
          </PermissionWrapper>
        </Col>
      </Row>
      <MyTable
        columns={columns()}
        data={props.data}
        onRowSelect={(record) => onRowSelect(record)}
      />
    </>
  );
};
const ActionComponent = ({ id, type, published }) => {
  const [popoverVisible, setPopoverVisible] = useState(false);
  const dispatch = useDispatch();
  const { currentUser } = useSelector((state) => state.users);
  const isAdmin = currentUser?.role === "Admin";
  const handleDeleteLandProject = (project_id) => {
    project_id = id;
    dispatch(
      deleteProject(
        project_id,
        "type=Land",
        successDeleteLandProject,
        failureDeleteLandProject,
      ),
    );
  };

  const successDeleteLandProject = () => {
    setTimeout(() => {
      message.success("You have successfully delete land project.");
    }, 2000);
  };
  const failureDeleteLandProject = () => {
    setTimeout(() => {
      message.info("Something went wrong.");
    }, 2000);
  };
  const handleUpdatePublished = () => {
    // event.preventDefault();
    setPopoverVisible(false);
    dispatch(publishedProject(id, type, true));
  };
  const handleUpdateUnPublished = () => {
    // event.preventDefault();
    setPopoverVisible(false);
    dispatch(publishedProject(id, type, false));
  };
  const content = (
    <div>
      {/* <ViewProperty id={id} />
      &nbsp;&nbsp; */}
      {/* <UpdateProperty id={id} />
      &nbsp;&nbsp; */}
      &nbsp;&nbsp;
      <PermissionWrapper resource="projects_land" action="show" disabled={true}>
        <ViewLandProjects id={id} setPopoverVisible={setPopoverVisible} />
      </PermissionWrapper>
      &nbsp;&nbsp;
      <PermissionWrapper
        resource="projects_land"
        action="update"
        disabled={true}
      >
        {published ? (
          <Button type="link" onClick={() => handleUpdateUnPublished()}>
            Un Published
          </Button>
        ) : (
          <Button type="link" onClick={() => handleUpdatePublished()}>
            Published
          </Button>
        )}
      </PermissionWrapper>
      &nbsp;&nbsp;
      <PermissionWrapper
        resource="projects_land"
        action="update"
        disabled={true}
      >
        <UpdateLandProjects id={id} setPopoverVisible={setPopoverVisible} />
      </PermissionWrapper>
      &nbsp;&nbsp;
      <PermissionWrapper
        resource="projects_land"
        action="destroy"
        disabled={true}
      >
        <Popconfirm
          title="Sure to delete?"
          // onConfirm={() => dispatch(deleteProject(id, type))}
          onConfirm={() => handleDeleteLandProject(id, type)}
        >
          <Button type="link" onClick={() => setPopoverVisible(false)}>
            Delete
          </Button>
        </Popconfirm>
      </PermissionWrapper>
    </div>
  );
  return (
    <Popover
      content={content}
      open={popoverVisible}
      trigger="click"
      onOpenChange={setPopoverVisible}
    >
      <Button type="link" onClick={() => setPopoverVisible(!popoverVisible)}>
        Action
      </Button>
    </Popover>
  );
};
